import { prefixerI } from '.'

export const ROUTE_REPORTE_103 = prefixerI('reporte-103')
export const ROUTE_REPORTE_104 = prefixerI('reporte-104')
export const ROUTE_REPORTE_107 = prefixerI('reporte-107')
export const ROUTE_EXCEL_COMPRAS_SERVICIOS = prefixerI('excel-compras-servicios')
export const ROUTE_REPORTE_TABULADO_RDEP = prefixerI('reporte-tabulado-rdep')
export const ROUTE_REPORTE_CONTROL_ERROR_USUARIO_CONTABLE = prefixerI('reporte-control-error-usuario-contable')
export const ROUTE_ATS_IMPORTACION = 'importacion:ats-importacion'
